export type InspectionItemStatus = (typeof InspectionItemStatuses)[keyof typeof InspectionItemStatuses];

export const InspectionItemStatuses = {
  PASSED: "passed",
  FAILED: "failed",
  EMPTY: null,
} as const;
